<template src= "./name_album.html"></template>

<script>
import optionData from '@/optionData/data'
import {ko} from 'vuejs-datepicker/dist/locale'
import agTableComp from '@/optionData/agTableComp'

export default {
    name: 'nameAlbum',
  
    data () {
        return {
            ko : ko,
            startDate :null,
            endDate : null,
            list :{
                data :[
                ],
                currentPage:1,
                pageSize: 10,
                totalPage : 0,
                gridOptions :{
                    onFirstDataRendered: (params)=>{
                        params.api.sizeColumnsToFit();
                    },

                    context: {
                        componentParent: this
                    },
                    onGridReady: function (event) {
                      
                    },
                    onRowClicked: (event)=>{
                    },
                    frameworkComponents :agTableComp,
                    
                    tabToNextCell:false,
                    navigateToNextCell:false,
                    getRowHeight:(params)=>{
                        return 94
                    }
                },
                columnDefs: [
                    {headerName: 'Action', field: 'validation_state', filter: false,minWidth:250, maxWidth:350,pinned: 'left',
                        cellRendererParams: {
                            //재매칭
                            clicked: (data) => {

                                if(data.type == 'match'){
                                    this.selectTrack = {}
                                    this.logTable.data = [data]
                                    this.keywordType = 'album_name'
                                    this.keyword = data.sl_album_name

                                    this.keywordType2 = null
                                    this.keyword2 = null

                                    this.searchList.currentPage = 1
                                    this.openModal(data.type)
                                    this.callSearchList(data.type)

                                }else if(data.type == 'reject'){
                                    this.confirm({
                                        title : '정산미반영',
                                        msg : `
                                            <p class="textLeft">
                                                트랙명 : ${data.sl_track_name ?data.sl_track_name : '-'} <br>
                                                트랙코드 : ${data.sl_track_ref ? data.sl_track_ref : '-'} <br>
                                                트랙UCI : ${data.sl_track_uci ? data.sl_track_uci : '-'} <br>
                                                앨범명 : ${data.sl_album_name ? data.sl_album_name : '-'} <br>
                                                앨범코드 : ${data.sl_album_ref ? data.sl_album_ref : '-' } <br>
                                            </p>
                                            <br>
                                            자사 권리곡이 아닌경우에만 미정산곡으로 처리해주세요.
                                            <br>
                                            미정산곡이 발생한 경우, 해당 내역은 해당 계약사에 안내되어야 합니다.
                                        `,
                                        width:600,
                                        autofocus : true,
                                        action : ()=>{
                                            console.log('data');
                                            console.log(data);
                                            let payload = {
                                                id : `${this.$route.params.id}`,
                                                params : {
                                                    "sl_album_barcode" : data.sl_album_barcode,
                                                    "sl_album_ref": data.sl_album_ref,
                                                    "sl_album_name": data.sl_album_name,
                                                    "sl_track_ref": data.sl_track_ref,
                                                    "sl_track_uci": data.sl_track_uci,
                                                    "sl_track_isrc": data.sl_track_isrc,
                                                    "sl_track_identifier1": data.sl_track_identifier1,
                                                    "sl_track_identifier2": data.sl_track_identifier2,
                                                    "sl_track_name": data.sl_track_name,
                                                    "validation_error": data.validation_error,
                                                }
                                            }
                                            
                                            this.loadingShow()
                                            this.$store.dispatch("IGNORE", payload)
                                            .then(result =>{
                                                this.loadingHide();
                                                this.noti('정산미반영 처리 되었습니다.')
                                                this.callList()
                                            }).catch(error =>{
                                                this.loadingHide();
                                                switch(error.response.data.code) {
                                                    default:
                                                    this.alert({msg:error})
                                                    break;
                                            }
                                            })
                                        }
                                    })
                                }else{
                                    this.confirm({
                                        title : '정산매칭확인',
                                        msg : `
                                            제대로 매칭이 된 것이 맞음을 확인합니다.
                                            <br>
                                            로그에 자사코드 형식이 아닌 코드가 왔다면, 이 코드는 트랙의 대체값으로 등록됩니다.
                                            <br>
                                            표기에 미묘한 차이가 있다면, 이 표기는 트랙의 대체명으로 등록됩니다.
                                        `,
                                        width:600,
                                        autofocus:true,
                                        action : ()=>{
                                            let payload = {
                                                id : `${this.$route.params.id}`,
                                                params : {
                                                    "sl_album_barcode" : data.sl_album_barcode,
                                                    "sl_album_ref": data.sl_album_ref,
                                                    "sl_album_name": data.sl_album_name,
                                                    "sl_track_ref": data.sl_track_ref,
                                                    "sl_track_uci": data.sl_track_uci,
                                                    "sl_track_isrc": data.sl_track_isrc,
                                                    "sl_track_identifier1": data.sl_track_identifier1,
                                                    "sl_track_identifier2": data.sl_track_identifier2,
                                                    "sl_track_name": data.sl_track_name,
                                                    "validation_error": data.validation_error,
                                                    "db_track_id": data.db_track_id,
                                                }
                                            }
                                            
                                            this.loadingShow()
                                            this.$store.dispatch("OK_MATCH", payload)
                                            .then(result =>{
                                                this.loadingHide();
                                                this.noti('정상매칭 처리 되었습니다.')
                                                this.callList()
                                            }).catch(error =>{
                                                this.loadingHide();
                                                switch(error.response.data.code) {
                                                    default:
                                                    this.alert({msg:error})
                                                    break;
                                            }
                                            })
                                        }
                                    })
                                }
                            },
                        },
                        cellRendererSelector: (data) => {
                            let dd ;
                           
                                dd={
                                    component: 'albumTrackAction',
                                    params: {
                                        ...data.data,
                                        text : data.value,
                                        mode:true
                                    }
                                } ;
                        
                        return dd
                    }},
                    {headerName: '오류 발생수', field: 'occurrance', filter: false, resizable: true, minWidth: 100, cellRendererSelector: (data) => {
                        let dd={
                            component: 'textRender',
                            params: {
                                ...data.data,
                                text:data.value
                            }
                        } ;
                        
                        return dd
                    } },
                    
                    {headerName: '구분', field: '', filter: false,minWidth: 80,
                    cellClass:"padding0 textCenter",
                    cellRendererParams: {
                        clicked: (data) => {
                            console.log(data)
                        }
                    },
                    cellRendererSelector: (data) => {
                        let dd={
                            component: 'compare',
                            params: {
                                ...data.data,
                                html1: '<span>LOG<span>',
                                html2: '<span>SRD<span>'
                            }
                        } ;
                        
                        return dd
                    }},
                    {headerName: '트랙코드', field: '', filter: false, resizable: true, minWidth: 150,
                    cellClass:"padding0",
                    cellRendererParams: {
                        clicked: (data) => {
                            console.log(data)
                        }
                    },
                    cellRendererSelector: (data) => {
                        let dd={
                            component: 'compare',
                            params: {
                                ...data.data,
                                html1: data.data.sl_track_ref,
                                html2: data.data.db_track_ref
                            }
                        } ;
                        
                        return dd
                    }},
                    {headerName: '앨범코드', field: '', filter: false,resizable: true, minWidth: 150, 
                    cellClass:"padding0",
                    cellRendererParams: {
                        clicked: (data) => {
                            console.log(data)
                        }
                    },
                    cellRendererSelector: (data) => {
                        let dd={
                            component: 'compare',
                            params: {
                                ...data.data,
                                html1: data.data.sl_album_ref,
                                html2: data.data.db_album_ref
                            }
                        } ;
                        
                        return dd
                    }},
                    {headerName: '앨범명', field: '', filter: false,resizable: true, minWidth: 250, width:450, 
                    cellClass:"padding0 red",
                    cellRendererParams: {
                        clicked: (data) => {
                            console.log(data)
                        }
                    },
                    cellRendererSelector: (data) => {
                        let dd={
                            component: 'compare',
                            params: {
                                ...data.data,
                                html1: data.data.sl_album_name,
                                html2: data.data.db_album_name
                            }
                        } ;
                        
                        return dd
                    }},
                    {headerName: '아티스트명', field: '', filter: false,resizable: true, minWidth: 250, width:450, 
                        cellClass:"padding0",
                        cellRendererParams: {
                            clicked: (data) => {
                                console.log(data)
                            }
                        },
                        cellRendererSelector: (data) => {
                            let dd={
                                component: 'compare',
                                params: {
                                    ...data.data,
                                    html1: data.data.sl_artists,
                                    html2: data.data.db_artists
                                }
                            } ;
                            
                            return dd
                    }},
                    
                    {headerName: '트랙명', field: '', filter: false,resizable: true, minWidth: 250, width:450, 
                    cellClass:"padding0",
                    cellRendererParams: {
                        clicked: (data) => {
                            console.log(data)
                        }
                    },
                    cellRendererSelector: (data) => {
                        let dd={
                            component: 'compare',
                            params: {
                                ...data.data,
                                html1: data.data.sl_track_name,
                                html2: data.data.db_track_name
                            }
                        } ;
                        
                        return dd
                    }},
                    {headerName: 'UPC/EAN', field: '', filter: false, minWidth: 150,
                    cellClass:"padding0",
                    cellRendererParams: {
                        clicked: (data) => {
                            console.log(data)
                        }
                    },
                    cellRendererSelector: (data) => {
                        let dd={
                            component: 'compare',
                            params: {
                                ...data.data,
                                html1: data.data.sl_album_barcode,
                                html2: data.data.db_album_barcode
                            }
                        } ;
                        
                        return dd
                    }},
                    {headerName: 'UCI', field: '', filter: false,minWidth: 350,
                    cellClass:"padding0",
                    cellRendererParams: {
                        clicked: (data) => {
                            console.log(data)
                        }
                    },
                    cellRendererSelector: (data) => {
                        let dd={
                            component: 'compare',
                            params: {
                                ...data.data,
                                html1: data.data.sl_track_uci,
                                html2: data.data.db_track_uci
                            }
                        } ;
                        
                        return dd
                    }},
                    {headerName: 'ISRC', field: '', filter: false,minWidth: 350,
                    cellClass:"padding0",
                    cellRendererParams: {
                        clicked: (data) => {
                            console.log(data)
                        }
                    },
                    cellRendererSelector: (data) => {
                        let dd={
                            component: 'compare',
                            params: {
                                ...data.data,
                                html1: data.data.sl_track_isrc,
                                html2: data.data.db_track_isrc
                            }
                        } ;
                        
                        return dd
                    }},

                ],
            },

            logTable :{
                data :[
                ],
                currentPage:1,
                pageSize: 5,
                totalPage : 0,
                gridOptions :{
                    context: {
                        componentParent: this
                    },
                    onGridReady: function (event) {
                      
                    },
                    onRowClicked: (event)=>{
                    },
                    frameworkComponents :agTableComp,
                    
                    tabToNextCell:false,
                    navigateToNextCell:false,
                    getRowHeight:(params)=>{
                        return 47
                    }
                },
                columnDefs: [
                    {headerName: '오류 발생수', field: 'occurrance',filter: false, resizable: true ,minWidth: 100,  },
                    {headerName: '트랙코드', field: 'sl_track_ref', filter: false, resizable: true ,minWidth: 200,},
                    {headerName: '앨범코드', field: 'sl_album_ref', filter: false, resizable: true ,minWidth: 200,},
                    {headerName: '앨범명', field: 'sl_album_name', filter: false, resizable: true ,width: 350,},
                    {headerName: '아티스트명', field: 'sl_artists', filter: false, resizable: true ,width: 250},
                    {headerName: '트랙명', field: 'sl_track_name', filter: false, resizable: true ,minWidth: 300,},
                    {headerName: 'UPC/EAN', field: 'sl_album_barcode', filter: false, resizable: true ,minWidth: 350,},
                    {headerName: 'UCI', field: 'sl_track_uci', filter: false, resizable: true ,minWidth: 350,},
                    {headerName: 'ISRC', field: 'sl_track_isrc', filter: false, resizable: true ,minWidth: 350,},
                ],
            },
            searchList:{
                data :[
                ],
                currentPage:1,
                pageSize: 5,
                totalPage : 0,
                gridOptions :{
                    context: {
                        componentParent: this
                    },
                    onGridReady: function (event) {
                      
                    },
                    onRowClicked: (event)=>{
                    },
                    frameworkComponents :agTableComp,
                    
                    tabToNextCell:false,
                    navigateToNextCell:false,
                    getRowHeight:(params)=>{
                        return 47
                    }
                },
                columnDefs: [
                    {headerName: '선택', field: 'Action',filter: false,width: 120,pinned: 'left', 
                    cellRendererParams: {
                        clicked: (data) => {
                             
                            this.selectTrack = {...data} 
                             
                            let log = this.logTable.data[0];
                            this.confirm({
                                title : '재매칭',
                                width :800,
                                msg : `
                                    <table class="tableInfo">
                                        <thead class="onlyDark">
                                            <tr>
                                                <th>구분</th>
                                                <th>로그 데이터</th>
                                                <th>SR 데이터</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            
                                            <tr>
                                                <th>트랙코드</th>
                                                <td>${log.sl_track_ref? log.sl_track_ref: '-'}</td>
                                                <td>${data.track_ref ? data.track_ref  : '-' }</td>
                                            </tr>
                                            <tr>
                                                <th>앨범코드</th>
                                                <td>${log.sl_album_ref? log.sl_album_ref: '-'}</td>
                                                <td>${data.album_ref? data.album_ref  : '-' }</td>
                                            </tr>
                                            <tr>
                                                <th>앨범명</th>
                                                <td>${log.sl_album_name? log.sl_album_name: '-'}</td>
                                                <td>${data.album_name? data.album_name  : '-' }</td>
                                            </tr>
                                            <tr>
                                                <th>아티스트명</th>
                                                <td>${log.sl_artists? log.sl_artists: '-'}</td>
                                                <td>${data.album_artists? data.album_artists.join(',')  : '-' }</td>
                                            </tr>
                                            <tr>
                                                <th>트랙명</th>
                                                <td>${log.sl_track_name? log.sl_track_name: '-'}</td>
                                                <td> ${data.track_name? data.track_name  : '-' }</td>
                                            </tr>
                                            <tr>
                                                <th>UCI</th>
                                                <td>${log.sl_track_uci? log.sl_track_uci: '-'}</td>
                                                <td>${data.track_uci? data.track_uci  : '-' }</td>
                                            </tr>
                                            <tr>
                                                <th>ISRC</th>
                                                <td>${log.sl_track_isrc ? log.sl_track_isrc :'-'}</td>
                                                <td>${data.track_isrc?data.track_isrc :'-'}</td>
                                            </tr>
                                            <tr>
                                                <th>UPC/EAN</th>
                                                <td>${log.sl_album_barcode ? log.sl_album_barcode : '-'}</td>
                                                <td>${data.album_barcode ? data.album_barcode : '-'}</td>
                                            </tr>
                                            
                                        </tbody>
                                    </table>
                                   
                                    
                                `,
                                action : ()=>{
                                    console.log('data');
                                    console.log(data);
                                    let payload = {
                                        id : `${this.$route.params.id}`,
                                        params : {
                                            "sl_album_ref": log.sl_album_ref,
                                            "sl_track_ref": log.sl_track_ref,
                                            "sl_track_uci": log.sl_track_uci,
                                            "sl_track_isrc": log.sl_track_isrc,
                                            "sl_track_identifier1": log.sl_track_identifier1,
                                            "sl_track_identifier2": log.sl_track_identifier2,
                                            "sl_track_name": log.sl_track_name,
                                            "sl_album_name": log.sl_album_name,
                                            "sl_album_barcode" : log.sl_album_barcode,
                                            "validation_error": log.validation_error,
                                            "db_track_id": data.track_id,
                                            "db_album_id": data.album_id
                                        }
                                    }
                                    
                                    this.loadingShow()
                                    this.$store.dispatch("RE_MATCH", payload)
                                    .then(result =>{
                                        this.loadingHide();
                                        this.closeModal('match')
                                        this.noti('재매칭 처리 되었습니다.')
                                        this.callList()
                                    }).catch(error =>{
                                        this.loadingHide();
                                        switch(error.response.data.code) {
                                            default:
                                            this.alert({msg:error})
                                            break;
                                    }
                                    })
                                }
                            })
                           
                        }
                    },
                    cellRendererSelector: (data) => {
                         let dd={
                            component: 'btnSelect',
                            params: {
                                ...data.data,
                                title: '선택'
                            }
                        } ;
                        // if(this.selectTrack.track_id ==  data.data.track_id ){
                        //     dd.params['disabled'] = true
                        //     dd.params['title'] = '선택완료'
                        // }
                        
                        return dd
                    }
                    },
                    {headerName: '트랙코드', field: 'track_ref', filter: false,width: 200, resizable: true},
                    {headerName: '앨범코드', field: 'album_ref', filter: false,minWidth: 200,resizable: true},
                    {headerName: '앨범명', field: 'album_name', filter: false,width: 350,resizable: true},
                    {headerName: '아티스트명', field: 'album_artists', filter: false,width: 250,resizable: true, cellRendererSelector: (data) => {
                        let t = data.value
                        let text =  ''
                        for ( var i in t ){
                            if(i != 0){
                            text += ', '
                            }
                            text += t[i].display_name
                        }
                        return text
                    }},
                    {headerName: '트랙명', field: 'track_name', filter: false, width: 350,resizable: true,},
                    {headerName: 'UPC/EAN', field: 'album_barcode', filter: false,minWidth: 350,resizable: true},
                    {headerName: 'UCI', field: 'track_uci', filter: false,minWidth: 350,resizable: true},
                    {headerName: 'ISRC', field: 'track_isrc', filter: false,minWidth: 350,resizable: true},
                ],
            },
            searchKeywordOption :[
                {value: 'sl_album_name', label:'앨범명'},
                {value: 'sl_track_name', label:'트랙명'},
                {value: 'sl_artists', label:'아티스트명'},
                {value: 'sl_album_ref',label: '앨범코드'},
                {value: 'sl_track_ref',label: '트랙코드'},
                {value: 'sl_album_barcode',label: 'UPC',},
                {value: 'sl_track_uci',label: 'Track UCI',},
                {value: 'sl_track_isrc',label: 'Track ISRC',},
                
                // sl_album_barcode: null
                // sl_album_name: "소망의 바다 미니스트리 The Story"
                // sl_album_ref: "SRC001322"
                // sl_artists: "소망의바다 미니스트리"
                // sl_track_identifier1: "339159"
                // sl_track_identifier2: null
                // sl_track_isrc: null
                // sl_track_name: "십자가의 전달자 (Feat. 김은현)"
                // sl_track_ref: "SRC00132201009"
                // sl_track_uci: "uci:i500-1000000762831.100005670920-1"
            ],
            searchKeywordType :null,
            searchKeyword : null,
            
            
            //재매칭
            keywordOption :[
                {value: 'album_name', label:'앨범명'},
                {value: 'track_name', label:'트랙명'},
                {value: 'album_artists', label:'아티스트명'},
                {value: 'album_ref',label: '앨범코드'},
                {value: 'track_ref',label: '트랙코드'},
                {value: 'album_barcode',label: 'UPC',},
                {value: 'track_uci',label: 'Track UCI',},
                {value: 'track_isrc',label: 'Track ISRC',},
                
                // - track_ref=
                // - track_name=
                // - track_isrc=
                // - track_uci=
                // - album_ref=
                // - album_name=
                // - album_barcode=
            ],
            

            keywordType :'track_name',
            keyword : '',
            keywordType2 :null,
            keyword2 : null,
            selectTrack : {
                id :null
            }
        }
    },
    created(){
        if(this.$route.query.page){
            this.list.currentPage= Number(this.$route.query.page)
        }
        
    },
    mounted(){
        this.$nextTick(() =>{
            this.callList()
        })
    },
    computed: {
        
    },
    watch: {
        'list.currentPage'(e){
            
            this.callList()
        },
        'searchList.currentPage'(){
            this.callSearchList()
        },
        'keywordType'(e){
            // {value: 'album_name', label:'앨범명'},
            // {value: 'track_name', label:'트랙명'},
            // {value: 'album_ref',label: '앨범코드'},
            // {value: 'track_ref',label: '트랙코드'},
            // {value: 'album_barcode',label: 'UPC',},
            // {value: 'track_uci',label: 'Track UCI',},
            // {value: 'track_isrc',label: 'Track ISRC',},
            console.log(this.logTable.data[0]);
            console.log(this.logTable.data[0]['sl_' + e])
            this.keyword = this.logTable.data[0]['sl_' + e]
            if(e == "album_artists" ){
                this.keyword = this.logTable.data[0]['sl_artists'] 
            }
        },
        'keywordType2'(e){
            // {value: 'album_name', label:'앨범명'},
            // {value: 'track_name', label:'트랙명'},
            // {value: 'album_ref',label: '앨범코드'},
            // {value: 'track_ref',label: '트랙코드'},
            // {value: 'album_barcode',label: 'UPC',},
            // {value: 'track_uci',label: 'Track UCI',},
            // {value: 'track_isrc',label: 'Track ISRC',},
            console.log(e);
            this.keyword2 = this.logTable.data[0]['sl_' +e]
            if(e == "album_artists" ){
                this.keyword2 = this.logTable.data[0]['sl_artists'] 
            }
        },
    },
    methods: {
        
        refresh () {
            // this.searchList.data[0].track_ref = '23e41324'
            // this.searchList.gridOptions.api.refreshCells()
            this.searchList.gridOptions.api.forEachNode(function(rowNode) {
                console.log(rowNode);
                rowNode.setDataValue('Action', rowNode.data['Action'] + 'd');
            });
        },
        callList(){
            let payload = {
                id : `${this.$route.params.id}`,
                params : {
                    error : 'album-name',  //track-code ,album-code ,track-name,album-name
                    page: this.list.currentPage-1 ,
                    limit: this.list.pageSize,
                }
            }
            if(!this.valCheck(this.searchKeywordType) && !this.valCheck(this.searchKeyword)){
                payload.params[this.searchKeywordType] = this.searchKeyword
            }
            this.loadingShow()
            this.$store.dispatch('GET_SALESLINEGROUP_ITEM_ERROR', payload)
            .then(result =>{
                console.log(result)
                this.errorName = name
                this.list.data  = result.items // 권리자 목록
                this.total = result.total // 총인원수 
                this.filtered = result.filtered // limit에 따른 수
                //페이지 수
                const remainder = parseInt(this.filtered % this.list.pageSize) > 0? 1: 0
                this.list.totalPage = parseInt(this.filtered/this.list.pageSize) + remainder
                setTimeout(() => {
                    this.openModal(name)
                    this.loadingHide()    
                }, 300);
                
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        
        list_search(){

        },
        callSearchList(type){
            const option = {
                page: this.searchList.currentPage-1 ,
                limit: this.searchList.pageSize,
            }
                
            let query = {}
            
            // - track_ref=
            // - track_name=
            // - track_isrc=
            // - track_uci=
            // - album_ref=
            // - album_name=
            // - album_barcode=
            if(this.keywordType && this.keyword != '') {
                option[this.keywordType] = this.keyword
                option['sort'] = this.keywordType
                option['sortorder'] = 'asc'
                if(this.keywordType ==  'album_ref'){
                    option['sort'] = 'track_ref'
                }
            }
            if(this.keywordType2 && this.keyword2 != '') {
                option[this.keywordType2] = this.keyword2
            }
            
            this.loadingShow();
            this.$store.dispatch('LIST_TRACK_MATCH', option)
            .then(result =>{
                this.loadingHide();
                
                this.searchList.data  = result.items // 권리자 목록
                
                this.total = result.total // 총인원수 
                this.filtered = result.filtered // limit에 따른 수
                //페이지 수
                const remainder = parseInt(this.filtered % this.searchList.pageSize) > 0? 1: 0
                this.searchList.totalPage = parseInt(this.filtered/this.searchList.pageSize) + remainder
                
            }).catch(error=>{
                this.loadingHide();
                const status = error.status
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                    break;
                }
            })
            
        },
     
    }
}
</script>

<style scoped>

</style>
